import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DealerSignUpModel} from '../../models/dealer-sign-up.model';

@Component({
  selector: 'app-dealer-sign-up-confirmation',
  templateUrl: './dealer-sign-up-confirmation.component.html',
  styleUrls: ['./dealer-sign-up-confirmation.component.css']
})
export class DealerSignUpConfirmationComponent  {
  @Input() model: DealerSignUpModel;
  @Output() closeEvent  = new EventEmitter<DealerSignUpModel>();

  async closeModal($event: MouseEvent) {
    this.closeEvent.emit(this.model);
  }
}



// WEBPACK FOOTER //
// ./src/app/dealer-sign-up/components/confirmation/dealer-sign-up-confirmation.component.ts